import request from '@/utils/request'

// 查询列表
export function apiBomProdLineList (query) {
  return request({
    url: '/bom/bomProdLine/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiBomProdLineNewExport (data) {
  return request({
    url: '/bom/bomProdLine/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiBomProdLineUpdate (data) {
  return request({
    url: '/bom/bomProdLine',
    method: 'put',
    data: data
  })
}

// 新增
export function apiBomProdLineAdd (data) {
  return request({
    url: '/bom/bomProdLine',
    method: 'post',
    data: data
  })
}

// 获取加工组织
export function apiGetInventOrgList (query) {
  return request({
    url: '/system/user/inventOrgList',
    method: 'get',
    params: query
  })
}

// 车间编码
export function apiBomWorkshopFindList (query) {
  return request({
    url: '/bom/bomWorkshop/findList',
    method: 'get',
    params: query
  })
}

// 产线编码
export function apiBomProdLineFindList (query) {
  return request({
    url: '/bom/bomProdLine/findList',
    method: 'get',
    params: query
  })
}

// 班次
export function apiRoutingCalendarShiftsList (query) {
  return request({
    url: '/bom/routingCalendar/shiftsList',
    method: 'get',
    params: query
  })
}
